import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="artote-preloader-wrapper">
        <div className="artote-preloader">
          <span></span>
          <span></span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated()) {
    // Redirect to login page with return url
    return <Navigate to="/login-register" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
